import { motion } from "framer-motion";
import { STATS } from "../../data/site";

export const Stats = () => (
  <section
    data-testid="stats-section"
    className="bg-[#F0ECE6] relative grain-light py-20 md:py-28"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
        <div className="max-w-2xl">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            The Numbers
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Thirty-five years of
            <br />
            <span className="font-serif-accent italic text-[#C05746]">consistent</span> protection.
          </h2>
        </div>
        <p className="text-[#5C5A55] max-w-sm text-base md:text-lg leading-relaxed">
          Termite work is measured in decades, not seasons. Here's what three of
          them have produced for our neighbors.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#E5DFD5]">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="relative bg-[#F9F7F4] border-r border-b border-[#E5DFD5] p-8 md:p-10 group hover:bg-white transition-colors"
          >
            <div className="font-display text-[#1C1B1A] text-5xl md:text-6xl lg:text-7xl tracking-tight group-hover:text-[#C05746] transition-colors">
              {s.value}
            </div>
            <div className="mt-4 text-[#1C1B1A] font-semibold text-sm uppercase tracking-[0.16em]">
              {s.label}
            </div>
            <div className="mt-2 text-[#5C5A55] text-sm leading-relaxed">{s.sub}</div>
            <div className="absolute top-4 right-4 text-[10px] text-[#5C5A55] font-mono">
              0{i + 1}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
